import { SET_SCORING_DATA_LOADED } from "@/store/metadata/metadataActions";
import { request } from "@/utils/api/legacyRequest";

export const UPDATE_USER_EVENT_ROLE = "events/UPDATE_USER_EVENT_ROLE";
export const SET_USER_UPDATE_SCORES = "SET_USER_UPDATE_SCORES";
export const UNSET_USER_UPDATE_SCORES = "UNSET_USER_UPDATE_SCORES";

function setResourceLabel(data) {
  return {
    type: "SET_RESOURCE_LABEL",
    data,
  };
}

// change the label for a resource role
export function putResourceLabel(userEventRoleId, resourceLabel = null) {
  return (dispatch, getState) => {
    const { user } = getState();
    const jwt = user.get("jwt");

    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v2/rebel/events/user-event-roles/${userEventRoleId}`;
    const payload = {
      user_event_role: {
        resource_label: resourceLabel,
      },
    };

    return request(url, jwt, "PUT", payload).then((response) => {
      dispatch({ type: UPDATE_USER_EVENT_ROLE, data: response.data });
      dispatch(setResourceLabel(response.data));
    });
  };
}

export function changeResourceLabel(userEventRoleId, label) {
  return (dispatch) => {
    dispatch(putResourceLabel(userEventRoleId, label));
  };
}

// SCORING
export const SET_ALL_HUB_EVENT_SCORING_ROUND_PROJECTS =
  "events/SET_ALL_HUB_EVENT_SCORING_ROUND_PROJECTS";

export function fetchAllHubEventScoringRoundProjects() {
  return (dispatch, getState) => {
    const { user } = getState();

    const jwt = user.get("jwt");
    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v2/rebel/events/hub-event-scoring-round-projects`;

    return request(url, jwt)
      .then((response) =>
        dispatch({
          type: SET_ALL_HUB_EVENT_SCORING_ROUND_PROJECTS,
          data: response.data,
        })
      )
      .catch((err) => console.error(err));
  };
}

export const SET_ALL_HUB_EVENT_SCORING_ROUND_PROJECT_SCORES =
  "events/SET_ALL_HUB_EVENT_SCORING_ROUND_PROJECT_SCORES";
export const SET_HUB_EVENT_SCORING_ROUND_PROJECT_SCORE =
  "events/SET_HUB_EVENT_SCORING_ROUND_PROJECT_SCORE";

export function fetchAllHubEventScoringRoundProjectScores() {
  return (dispatch, getState) => {
    const { user } = getState();

    const jwt = user.get("jwt");
    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v2/rebel/events/hub-event-scoring-round-project-scores`;

    return request(url, jwt)
      .then((response) =>
        dispatch({
          type: SET_ALL_HUB_EVENT_SCORING_ROUND_PROJECT_SCORES,
          data: response.data,
        })
      )
      .catch((err) => console.error(err));
  };
}

export function submitHubEventScoringProjectScore(
  hubEventScoringRoundProjectId,
  scores
) {
  return (dispatch, getState) => {
    const { user } = getState();

    const jwt = user.get("jwt");
    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v2/rebel/events/hub-event-scoring-round-project-scores/`;

    const payload = {
      hub_event_scoring_round_project_score: {
        event_scoring_round_project_id: hubEventScoringRoundProjectId,
        scores,
      },
    };
    dispatch({ type: SET_USER_UPDATE_SCORES });

    request(url, jwt, "POST", payload)
      .then((response) => {
        dispatch({
          type: SET_HUB_EVENT_SCORING_ROUND_PROJECT_SCORE,
          data: response.data,
        });
        dispatch({ type: UNSET_USER_UPDATE_SCORES });
      })
      .catch((err) => console.error(err));
  };
}

export const fetchScoringRoundsData = () => (dispatch, getState) => {
  const { metadata } = getState();
  const scoringDataLoaded = metadata.loading.get("scoringDataLoaded");
  if (scoringDataLoaded) return;
  Promise.all([
    dispatch(fetchAllHubEventScoringRoundProjectScores()),
    dispatch(fetchAllHubEventScoringRoundProjects()),
  ]).then(() => dispatch({ type: SET_SCORING_DATA_LOADED }));
};
